import React from 'react';
import { VoiceConnectionType } from '../../services/cxone-sdk.service';
import formStyles from './VoicePreferencesForm.module.css';

interface VoicePreferenceOptionProps {
  type: VoiceConnectionType;
  selectedType: VoiceConnectionType;
  title: string;
  description: string;
  iconPath: string;
  disabled?: boolean;
  onSelect: (type: VoiceConnectionType) => void;
}

export function VoicePreferenceOption({
  type,
  selectedType,
  title,
  description,
  iconPath,
  disabled = false,
  onSelect,
}: VoicePreferenceOptionProps) {
  return (
    <label className={`${formStyles.option} ${selectedType === type ? formStyles.selected : ''}`}>
      <input
        type="radio"
        name="voiceType"
        value={type}
        checked={selectedType === type}
        onChange={() => onSelect(type)}
        disabled={disabled}
      />
      <div className={formStyles.optionIcon}>
        <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
          <path d={iconPath} />
        </svg>
      </div>
      <div className={formStyles.optionContent}>
        <span className={formStyles.optionTitle}>{title}</span>
        <span className={formStyles.optionDescription}>{description}</span>
      </div>
      <div className={formStyles.radioIndicator} />
    </label>
  );
}
